import { buildContextStore } from "../../stores/buildContext";
import { get } from "svelte/store";

export const getDelay = (delay?: number) => get(buildContextStore).poller.getDelay(delay);
